import { ReconciliationSummarizedCostData } from '../../../redux/features/selectors/selectReconciliationData.ts';
import { ReconciliationPageData } from '../types.ts';

type CommentaryV2 = {
  reconciliation?: Partial<ReconciliationPageData>;
  [key: string]: unknown;
};

/**
 * Build reconciliation page data for PDF
 */
export const buildReconciliationData = (
  commentaryV2: CommentaryV2,
  aivReconciliationSummarizedValues: ReconciliationSummarizedCostData,
  arvReconciliationSummarizedValues: ReconciliationSummarizedCostData | undefined,
  hasArvOption: boolean,
): ReconciliationPageData => {
  const reconciliationPageData: ReconciliationPageData = {
    ...commentaryV2?.reconciliation,
    aiv: { ...aivReconciliationSummarizedValues },
  };

  if (hasArvOption && arvReconciliationSummarizedValues) {
    reconciliationPageData.arv = {
      ...arvReconciliationSummarizedValues,
    };
  }

  return reconciliationPageData;
};
